import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractRearJacket from "../RearJacket";

class RearJacket extends AbstractRearJacket {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-rear-jackets-ipr';
  }
}

export default RearJacket;
